import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p421625506456068096',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
